import { useContext, useEffect } from "react";

import { Stepper } from "../Stepper";
import { StepperContext } from "../../Contexts/Stepper";
import { LanguageContext } from "../../Contexts/Language";
import { Step1 } from "../Step1";
import { Step2 } from "../Step2";
import { Step3 } from "../Step3";
import { Step4 } from "../Step4";
import { LANGUAGES } from "../../utils/constants";
import messages from "../../utils/messages";

export const Form = () => {
  const { step, setStep } = useContext(StepperContext);
  const { lang, setLang } = useContext(LanguageContext);

  const { languageBtn, deleteAccount } = messages[lang];

  useEffect(() => {
    const userLang = navigator.language || navigator.userLanguage;
    setLang(userLang && userLang === "ar" ? LANGUAGES.ar : LANGUAGES.en);
  }, []);

  return (
    <div
      className={`${lang === LANGUAGES.en ? "ltr" : "rtl"}`}
      dir={lang === LANGUAGES.en ? "ltr" : "rtl"}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px 5% 0 5%",
        }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}>
          <i
            style={{
              fontSize: "24px",
              display: step > 1 && step !== 4 ? "block" : "none",
            }}
            className={`fa ${
              lang === LANGUAGES.en ? "fa-chevron-left" : "fa-chevron-right"
            }`}
            onClick={() => {
              setStep(step - 1);
            }}></i>
          <h3
            style={{
              margin: step > 1 && step !== 4 ? "0 20px" : "0",
            }}>
            {deleteAccount}
          </h3>
        </div>
        <div>
          <button
            className="lang-switcher pointer"
            style={{
              padding:
                lang === LANGUAGES.en ? "5px 10px 10px 10px" : "5px 10px",
              display: "flex",
              alignItems: lang === LANGUAGES.en ? "end" : "center",
              justifyContent: "space-around",
            }}
            onClick={() => {
              setLang(lang === LANGUAGES.en ? LANGUAGES.ar : LANGUAGES.en);
            }}>
            <i
              style={{
                fontSize: "18px",
              }}
              className={`fa fa-globe`}></i>
            <span
              style={{
                marginLeft: lang === LANGUAGES.en ? "5px" : "0",
                marginRight: lang === LANGUAGES.en ? "0" : "5px",
              }}>
              {languageBtn}
            </span>
          </button>
        </div>
      </div>
      <Stepper />
      <div className="steps-container">
        {step === 1 && <Step1 />}
        {step === 2 && <Step2 />}
        {step === 3 && <Step3 />}
        {step === 4 && <Step4 />}
      </div>
    </div>
  );
};
